"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const valueToText = (val) => {
    return val
        .map(ch => 'char' in ch ? ch.char : null)
        .filter(ch => ch != null).join('');
};
exports.default = valueToText;
//# sourceMappingURL=valueToText.js.map